import { isNotNil } from "ramda";
import {
	ComponentType,
	FunctionComponent,
	PropsWithChildren,
	ReactNode,
} from "react";

/**
 * Internal Provider representation.
 */
type Provider<TProps> = {
	Component: ComponentType<PropsWithChildren<TProps>>;
	props?: Omit<TProps, "children">;
};

export function createProvider<TProps>(
	Component: ComponentType<PropsWithChildren<TProps>>,
	props?: Omit<TProps, "children">,
): Provider<TProps> {
	return { Component, props };
}

export function composeProviders(
	providers: (Provider<any> | null)[],
): ComponentType<PropsWithChildren> {
	const ProviderComponent: FunctionComponent<PropsWithChildren> = ({
		children,
	}) =>
		providers
			.filter((entry) => isNotNil(entry))
			.reduceRight<ReactNode>(
				(prevElement, { Component: CurrentProvider, props = {} }) => (
					<CurrentProvider {...props}>{prevElement}</CurrentProvider>
				),
				children,
			);

	return ProviderComponent;
}
